import { inject } from "@angular/core";
import {
  CanActivateFn,
  Router,
  UrlTree,
} from "@angular/router";

import { sessionStore } from "@auvious/utils";
import {
  CobrowseContextEnum,
  KEY_COBROWSE_CONTEXT,
  KEY_COBROWSE_SESSION_ID,
  KEY_REDIRECT_URI,
  PARAM_AUTH_ATTEMPT,
} from "../../../core-ui/core-ui.enums";
import { AppConfigService } from "../../../core-ui/services/app.config.service";
import { PublicParam } from "../../../core-ui/models/application-options/PublicOptions";

export const authRedirectGuard: CanActivateFn = async (
  route,
  state
): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const config = inject(AppConfigService);

  const redirectUri = sessionStore.getItem(KEY_REDIRECT_URI);
  // we are signed in, so the navigations this instance counted on its way here are over
  const queryParams = { ...route.queryParams, [PARAM_AUTH_ATTEMPT]: null };
  if (!redirectUri) {
    // if we don't know where to go, go to welcome
    if (route.url[0].path === "redirect") {
      return router.createUrlTree(["/welcome"], { queryParams });
    }

    const existingSession = sessionStore.getItem(KEY_COBROWSE_SESSION_ID);
    const existingSessionContext = sessionStore.getItem(KEY_COBROWSE_CONTEXT);
    if (
      existingSession &&
      existingSessionContext === CobrowseContextEnum.STANDALONE
    ) {
      return router.createUrlTree(["/cobrowse"], { queryParams });
    }

    // otherwise continue in the page we are
    return true;
  }
  sessionStore.removeItem(KEY_REDIRECT_URI);

  // remove authentication related keys since they are only used to get the access token
  return router.createUrlTree([redirectUri], {
    queryParams: {
      ...queryParams,
      // the key for the session stored access token is the code so we need to keep it
      code: config.publicParam(
        PublicParam.ACCESS_TOKEN_AGENT_SESSION_STORE_ENABLED
      )
        ? route.queryParamMap.get("code")
        : null,
      prompt: null,
      authuser: null,
      scope: null,
    },
  });
};
